export default {
  /// <summary>
  /// Quyền xem
  /// </summary>
  View: 1,
  /// <summary>
  /// Quyền thêm
  /// </summary>
  Add: 2,
  /// <summary>
  /// Quyền sửa
  /// </summary>
  Edit: 4,
  /// <summary>
  /// Quyền xóa
  /// </summary>
  Delete: 8,
  /// <summary>
  /// Quyền ghi sổ
  /// </summary>
  Posted: 16,
  /// <summary>
  /// Quyền bỏ ghi
  /// </summary>
  UnPost: 32,
  /// <summary>
  /// Quyền in
  /// </summary>
  Print: 64,
  /// <summary>
  /// Phát hành hóa đơn
  /// </summary>
  ReleaseEInvoice: 128,
  /// <summary>
  /// Gửi hóa đơn
  /// </summary>
  SendInvoice: 256,
  /// <summary>
  /// Chuyển thành chứng từ giấy
  /// </summary>
  ConvertIntoPaperVoucher: 512,
  /// <summary>
  /// Tải hóa đơn
  /// </summary>
  DownloadInvoice: 1024,
  /// <summary>
  /// Hủy hóa đơn
  /// </summary>
  CancelInvoice: 2048,
  /**
   * Tùy chỉnh giao diện
   */
  SettingLayout:4096,
};
